import { render, staticRenderFns } from "./admin_qyhx.vue?vue&type=template&id=3629c7b4&scoped=true"
import script from "./admin_qyhx.vue?vue&type=script&lang=js"
export * from "./admin_qyhx.vue?vue&type=script&lang=js"
import style0 from "./admin_qyhx.vue?vue&type=style&index=0&id=3629c7b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629c7b4",
  null
  
)

export default component.exports